import { createSelector } from 'reselect'

import { selectCockpitPartnerData } from './selectCockpitPartnerData'
import { selectCockpitRtm } from './selectCockpitRtm'

export const selectCockpitPartnerIdsForSelectedRtm = createSelector(
  [selectCockpitPartnerData, selectCockpitRtm],
  (partnerData, selectedRtm) =>
    new Set(
      partnerData
        .filter((partner) =>
          selectedRtm === 'resellers' ? partner.IsCommercial === 1 : partner.IsDistributor === 1
        )
        .map(({ PartnerId }) => PartnerId)
    )
)
